import Accounts from './Accounts';
import Webhooks from './Webhooks';

const Settings = () => {
    return (
        <div className="w-full overflow-x-auto">
            <div className="mb-6 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                <h1 className="text-2xl font-bold text-gray-800">Settings</h1>
            </div>
            <div className="flex flex-col w-full gap-5">
                <div className="bg-white border-collapse border-[1px] border-gray-300 rounded-xl shadow-sm overflow-hidden p-6">
                    <Webhooks />
                </div>
                <div className="bg-white border-collapse border-[1px] border-gray-300 rounded-xl shadow-sm overflow-hidden p-6">
                    <Accounts />
                </div>
            </div>
        </div>
    );
};

export default Settings;
